import { Routes } from '@angular/router';
import { AuthCallbackComponent } from '../QualityBidders/authentication/auth-callback/auth-callback.component';
import { AuthMessageComponent } from '../QualityBidders/authentication/auth-message/auth-message.component';
import { LoginComponent } from '../QualityBidders/authentication/login/login.component';
import { LogoutComponent } from '../QualityBidders/authentication/logout/logout.component';
import { PasswordChangedComponent } from '../QualityBidders/authentication/password-changed/password-changed.component';
import { SignUpComponent } from '../QualityBidders/authentication/sign-up/sign-up.component';
import { AuthGuard, RoleTypeGuard } from '../QualityBidders/core/guards';
import { PermissionGuard } from '../QualityBidders/core/guards/permission.guard';
import { OpportunitiesComponent } from '../QualityBidders/opportunities/opportunities.component';
import { ConfirmAccountComponent } from '../QualityBidders/public/confirm-account/confirm-account.component';
import { ConfirmationSentComponent } from '../QualityBidders/public/confirmation-sent/confirmation-sent.component';
import { PrivacyPolicyComponent } from '../QualityBidders/public/privacy-policy/privacy-policy.component';
import { ConfirmEmailChangeComponent } from '../QualityBidders/settings/confirm-email-change/confirm-email-change.component';
import { LausdHomeComponent } from './home/home.component';

export const lausdRoutes: Routes = [
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    data: {
      title: 'Privacy Policy',
      showMaster: false,
    },
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'verify',
    component: SignUpComponent,
  },
  {
    path: 'password-changed',
    component: PasswordChangedComponent,
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
  },
  {
    path: 'auth-msg',
    component: AuthMessageComponent,
  },
  {
    path: 'confirmation-sent/:vendorToken',
    component: ConfirmationSentComponent,
    data: {
      title: 'Confirmation Email Sent',
      showMaster: false,
    },
  },
  {
    path: 'account-confirmed/:vendorToken/:confirmationKey',
    component: ConfirmAccountComponent,
    data: {
      title: 'Confirm Account',
      showMaster: false,
    },
  },
  {
    path: 'confirm-email-change/:confirmationKey',
    component: ConfirmEmailChangeComponent,
    title: 'Confirm Email Change',
    data: {
      showMaster: true,
    },
  },
  {
    path: 'opportunities',
    component: OpportunitiesComponent,
    data: {
      title: 'Opportunities',
      showMaster: true,
    },
  },
  {
    path: 'about',
    redirectTo: () => {
      window.open('https://www.colbitech.com/qualitybidders', '_blank');
      return '';
    },
  },
  {
    path: 'help',
    loadChildren: () => import('./public/help/help.routes').then(m => m.HELP_ROUTES),
  },
  // {
  //   path: 'contacts',
  //   component: ContactComponent,
  //   data: {
  //     title: 'QualityBidders Contact Us',
  //     showMaster: true,
  //   },
  // },
  {
    path: 'admin',
    canLoad: [AuthGuard, RoleTypeGuard],
    canActivate: [AuthGuard, RoleTypeGuard, PermissionGuard('colbi_admin:view')],
    data: {
      allowedRoles: ['colbi'],
    },
    loadChildren: () => import('../QualityBidders/admin/admin.routes').then(m => m.ADMIN_ROUTES),
  },
  //   children: [
  //     {
  //       path: 'prime',
  //       data: {
  //         isPrequal: true,
  //       },
  //       children: [
  //         {
  //           path: '',
  //           pathMatch: 'full',
  //           redirectTo: 'fifo',
  //         },
  //         {
  //           path: 'fifo',
  //           component: QbatPrequalAppListComponent,
  //           data: { title: 'App List' },
  //         },
  //         {
  //           path: 'fifo/:id',
  //           component: QbatPrequalAppViewComponent,
  //           data: { title: 'Prequal Fifo App View' },
  //         },
  //         {
  //           path: 'agencies/:id',
  //           component: QbatPrequalAppViewComponent,
  //           data: { title: 'Prequal Agencies App View' },
  //         },
  //         {
  //           path: 'contractors/:id',
  //           component: QbatPrequalAppViewComponent,
  //           data: { title: 'Prequal Contractors App View' },
  //         },
  //         {
  //           path: 'contractors',
  //           component: QbatPrequalContractorsListComponent,
  //           data: { title: 'Prequal Contractors List' },
  //         },
  //         {
  //           path: 'contractors/:id/apps',
  //           component: QbatPrequalContractorsAppComponent,
  //           data: { title: 'Prequal Contractor Apps List' },
  //         },
  //         {
  //           path: 'agencies',
  //           component: QbatPrequalAgenciesListComponent,
  //           data: { title: 'Prequal Agencies List' },
  //         },
  //         {
  //           path: 'agencies/:id/apps',
  //           component: QbatPrequalAgenciesAppComponent,
  //           data: { title: 'Prequal Agency Apps List' },
  //         },
  //       ],
  //     },

  //     {
  //       path: 'safety',
  //       data: {
  //         isSafety: true,
  //       },
  //       children: [
  //         {
  //           path: '',
  //           pathMatch: 'full',
  //           redirectTo: 'fifo',
  //         },
  //         // {
  //         //   path: 'fifo',
  //         //   component: QbatSafetyAppListComponent,
  //         //   data: { title: 'Safety Apps List' },
  //         // },
  //         // {
  //         //   path: 'fifo/:id',
  //         //   component: QbatSafetyAppViewComponent,
  //         //   data: { title: 'Safety FIFO App View' },
  //         // },
  //         // {
  //         //   path: 'agencies/:id',
  //         //   component: QbatSafetyAppViewComponent,
  //         //   data: { title: 'Safety Agencies App View' },
  //         // },
  //         // {
  //         //   path: 'contractors/:id',
  //         //   component: QbatSafetyAppViewComponent,
  //         //   data: { title: 'Safety Contractors App View' },
  //         // },
  //         // {
  //         //   path: 'contractors',
  //         //   component: QbatSafetyContractorsListComponent,
  //         //   data: { title: 'Safety Contractors List' },
  //         // },
  //         // {
  //         //   path: 'contractors/:id/apps',
  //         //   component: QbatSafetyContractorsAppComponent,
  //         //   data: { title: 'Safety Contractor Apps List' },
  //         // },
  //         // {
  //         //   path: 'agencies',
  //         //   component: QbatSafetyAgenciesListComponent,
  //         //   data: { title: 'Safety Agencies List' },
  //         // },
  //         // {
  //         //   path: 'agencies/:id/apps',
  //         //   component: QbatSafetyAgenciesAppComponent,
  //         //   data: { title: 'Safety Agency Apps List' },
  //         // },
  //       ],
  //     },
  //   ],
  // },
  {
    path: 'vendor',
    canLoad: [AuthGuard, RoleTypeGuard],
    canActivate: [AuthGuard, RoleTypeGuard],
    data: {
      allowedRoles: ['vendor'],
    },
    loadChildren: () => import('./vendor/vendor.routes').then(m => m.LAUSD_VENDOR_ROUTES),
  },
  {
    path: 'agency',
    canLoad: [AuthGuard, RoleTypeGuard],
    canActivate: [AuthGuard, RoleTypeGuard, PermissionGuard],
    data: {
      allowedRoles: ['agency'],
    },
    loadChildren: () => import('./agency/agency.routes').then(m => m.LAUSD_AGENCY_ROUTES),
  },
  {
    path: 'settings',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('./settings/settings.routes').then(m => m.LAUSD_SETTINGS_ROUTES),
  },
  {
    path: 'confirm-email-change/:confirmationKey',
    component: ConfirmEmailChangeComponent,
  },
  {
    path: '',
    component: LausdHomeComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
